import api from "@/libs/axios";
import { QueryConfig } from "@/libs/query";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { apiEnum } from "@/pages/taskpane/shared/types/enums/apiEnum";
import { QUERY_KEY } from "@/pages/taskpane/shared/constants/queryKey";
import { ConfigurationEntity } from "./entities/ConfigurationEntity";

type payloadType = {
    parameters: {
        keys: string[];
    };
}
const getConfiguration = async (
    payload: payloadType
): Promise<ConfigurationEntity> => {
    const { data } = await api.post(apiEnum.configuration, payload);
    return new ConfigurationEntity(data?.data || {});
};

const options = (payload: payloadType) =>
    queryOptions({
        queryKey: [QUERY_KEY.GET_APP_DATA, payload.parameters.keys],
        queryFn: () => getConfiguration(payload),

        // ✅ Cache strategy for app config data
        staleTime: 2 * 60 * 1000, // Fresh for 2 minutes
        gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes
        refetchOnMount: false, // Don't refetch if cache is fresh
        refetchOnWindowFocus: false, // Don't refetch on window focus
        refetchOnReconnect: true, // Refetch when reconnect to internet
    });

type UseGetConfigurationDataType = {
    queryConfig?: QueryConfig<typeof options>;
    payload: payloadType;
};

export const useGetConfiguration = ({ queryConfig, payload }: UseGetConfigurationDataType) => {
    return useQuery({
        ...options(payload),
        ...queryConfig,
    });
};